import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { Channel, MultichannelDashboards } from './types';

export const getMultichannelDashboard = (
  accountId: string,
  projectId: string,
  startAt: string,
  endAt: string,
  channel: string,
  interval: string,
  timezone: string,
) => {
  return doGet<MultichannelDashboards[Channel]>(
    `accounts/${accountId}/projects/${projectId}/multi-channel-dashboards/${channel}`,
    LOGGER_TYPE.ANALYTICS,
    {
      prefix: 'nebula',
      params: {
        start_at: startAt,
        end_at: endAt,
        interval,
        timezone,
      },
    },
  );
};
